import React, {useState, useEffect, useCallback} from "react";
import ProductListed from '../../components/ProductListed';
import ProductBenchmark from '../../components/ProductBenchmark';
import ChartRadar from '../../components/ChartRadar';
import Aside from "../../container/Aside";
import {scrollTo} from '../../lib/utils';
import "./Radar.css";

export default function Radar (props) {

  const {items, benchmarks, chartProps, selected, toggleProducts, toggleLayer, properties, scrolled} = props;
  const [chart, setChart] = useState([]);
  const [max, setMax] = useState(0);
  const [benchmark, setBenchmark] = useState();
  const [mounted, setMounted] = useState(false);
  const [hover, setHover] = useState();

  const getChartData = useCallback(() => {
    const currProps = chartProps
      .map(item => properties.filter(prop => prop.key === item)[0] || null).filter(item => item);
    return currProps.reduce((acc, curr) => {
        const currProps = [benchmark, ...items].filter(item => item && item.color).map((item, index) => {
          const prop = item.properties.filter(prop => prop.key === curr.key)[0];
          const value = prop.normalized === -1 ? 0 : prop.normalized;//toNum(prop.normalized.toString(), prop.key);
          return value;// === 0 ? 2 : value;//randomRange(0.5, 4)
        });
        return [...acc, {subject: curr.label, ...currProps.map((value, key) => value)}]
      }, []);
  }, [items, benchmark, properties, chartProps]);

  useEffect(() => {
    if(!mounted){
      setMounted(true);
      scrollTo();
    }
    if(items.length && properties.length){
      const chartData = getChartData();
      if(chartData !== chart) {
        const maxValue = chartData
          .reduce((acc, curr) => [...acc, ...[benchmark, ...items.filter(item => item.color)].filter(item => item).map((el, i) => curr[i])], [])
          .reduce((acc, curr) => curr > acc ? curr : acc, 0);
        setMax(parseInt(maxValue)+1);
        setChart(chartData.map(item => ({...item, fullMark: maxValue})));
      }
    }
  }, [mounted, items, benchmark]);

  return (
    <section className="view radar clear">
      <div className="chart">
      {chart && !!chart.length &&


        <ChartRadar 
          data={chart}
          product={hover}
          items={[benchmark, ...items].filter(item => item)}
          max={max}
          toggleLayer={() => toggleLayer("radar")}
        />
      }
      </div>
      <Aside scrolled={scrolled}>
        <ProductBenchmark
          data={benchmarks}
          benchmark={benchmark}
          toggleLayer={toggleLayer}
          setBenchmark={(item) => setBenchmark(item === benchmark ? null : item)}
          toggleColor={() => setBenchmark({...benchmark, color: !!benchmark.color ? null : "#000000"})}
          onMouseEnter={() => setHover(benchmark)}
          onMouseLeave={() => setHover()}
        />
        <ul>
        {items.map((item, index) =>
          <li key={index}>
            <ProductListed
              compact colorOption
              onMouseEnter={item.color ? () => setHover(item) : () => setHover()}
              onMouseLeave={() => setHover()}
              data={item}
              toggleLayer={() => toggleLayer(item)}
              selected={selected.indexOf(item.id) > -1}
              toggle={toggleProducts}
            />
          </li>
        )}
        </ul>
      </Aside>

    </section>
  )
}
